import React from 'react';

const AnimatedEllipsis = () => (
  <span className="animated-ellipsis">
    <span>.</span><span>.</span><span>.</span>
  </span>
);

export default AnimatedEllipsis;
